import { observer } from 'mobx-react'
import React from 'react'

import { isMobile } from '@flowwai-frontend/shared/utils/web'

import useClientConfig from '../../config/useClientConfig'
import LaunchingModeUI from '../../components/LaunchingModeUI/LaunchingModeUI'
import LaunchingModeMobileViewUI from '../../components/LaunchingModeUI/LaunchingModeMobileViewUI'

const LaunchingModeController = (): React.ReactElement => {
   const { appMode, logoURL, logoWidth, mobileLogoWidth } = useClientConfig()

   const isMobileView = isMobile()

   const { title, copyrightsText } = appMode['LAUNCHING_MODE']

   const renderMobilView = (): React.ReactElement => (
      <LaunchingModeMobileViewUI
         logoUrl={logoURL}
         logoWidth={mobileLogoWidth}
         title={title}
         copyrightsText={copyrightsText}
      />
   )

   const renderWebView = (): React.ReactElement => (
      <LaunchingModeUI
         logoUrl={logoURL}
         logoWidth={logoWidth}
         title={title}
         copyrightsText={copyrightsText}
      />
   )

   return isMobileView ? renderMobilView() : renderWebView()
}

export default observer(LaunchingModeController)
